import React from 'react';
import IronDomeImporter from '../../../components/IronDomeImporter';

function ImportIronDome({ importFunction, setLoading, fetchData }) {
  return (
    <IronDomeImporter
      type="offer"
      importFunction={importFunction}
      setLoading={setLoading}
      fetchData={fetchData}
    />
  );
}

export default ImportIronDome;